import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Box } from "@mui/material";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Title, Legend, ChartDataLabels);

export function ExportTIMChartV({
  questions,
  positiveColor = "#69AF45",
  negativeColor = "#2B8DCC",
}) {
  const labels = questions.map((_, idx) => `Q${idx + 1}`);
  const positives = questions.map((q) => q.positive);
  const negatives = questions.map((q) => q.negative);

  const chartData = {
    labels,
    datasets: [
      { label: "Positive", data: positives, backgroundColor: positiveColor },
      { label: "Negative", data: negatives, backgroundColor: negativeColor },
    ],
  };

  const options = {
    indexAxis: "x",
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rectRounded",
          padding: 10,
          font: { size: 12 },
        },
      },
      tooltip: { enabled: false },
      datalabels: {
        color: "#FFFFFF",
        font: { size: 11, weight: "bold" },
        anchor: "center",
        align: "center",
        formatter: (value) => (!value || value === 0 ? "" : `${value}%`),
      },
      title: { display: false },
    },
    scales: {
      x: {
        type: "category",
        ticks: { font: { size: 12, weight: "bold" } },
        grid: {
          display: true,
          color: "#105385",
          lineWidth: 1.2,
          drawOnChartArea: true,
          drawTicks: false,
          offset: true,
        },
      },
      y: {
        type: "linear",
        min: 0,
        max: 100,
        ticks: {
          stepSize: 25,
          callback: (value) => `${value}%`,
          font: { size: 11 },
        },
      },
    },
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: 280, sm: 340, md: 400 },
        position: "relative",
      }}
    >
      <Bar data={chartData} options={options} />
    </Box>
  );
}
